module.exports = __webpack_public_path__ + "img/undraw_profile_pic_ic5t.6b0cfaaa.svg";